import(/* webpackMode: "eager", webpackExports: ["Human"] */ "/home/pubky/cicd/actions-runner/_work/pubky-stack/pubky-stack/pubky-app/src/components/templates/Onboarding/Human/Human.tsx");
